<!-- 横向并列的两个面板布局容器 用于零售终端页面 -->
<template>
  <el-container>
    <el-aside
      :width="$pxToRem(406)"
      :style="{
        marginRight: $pxToRem(8),
      }"
    >
      <el-container style="height: 100%">
        <el-header :height="$pxToRem(40)" class="p-none-important mb-8" v-if="showSearchForm">
          <el-form
            inline
            ref="searchForm"
            label-width="auto"
            :model="searchForm"
            size="medium"
            class="search-form"
            @keydown.enter.native.prevent="handleSearch"
          >
            <el-form-item class="searchkey-form-item" :prop="searchKeyField" :rules="searchRules">
              <el-input
                ref="headInput"
                clearable
                size="medium"
                v-model="searchForm[searchKeyField]"
                :placeholder="searchPlaceholder"
              ></el-input>
            </el-form-item>
            <el-form-item class="search-form__button" style="margin-right: 0">
              <el-button size="small" type="primary" @click="handleSearch">{{ $MGUI.i18n.t('查询') }}</el-button>
              <el-button
                ref="add"
                size="small"
                type="primary"
                v-permission:add
                @click="handleAdd"
                style="vertical-align: top"
              >
                <div class="leading-none">{{ $MGUI.i18n.t('新增') }}</div>
                <div class="leading-none" style="font-size: 12px">[F10]</div>
              </el-button>

              <el-popover
                v-if="more"
                popper-class="search-form__more"
                placement="bottom"
                trigger="click"
                :style="{ marginLeft: $pxToRem(8) }"
              >
                <el-button slot="reference" size="small" type="primary" plain>{{ $MGUI.i18n.t('更多') }}</el-button>
                <div class="more-actions flex flex-col">
                  <el-button v-if="more?.moreSearch" size="small" @click="moreSearch">
                    {{ $MGUI.i18n.t('更多查询') }}
                  </el-button>
                  <template v-if="more?.actions">
                    <el-button v-for="action in more.actions" :key="action.value" size="small" @click="action.handler">
                      {{ action.label }}
                    </el-button>
                  </template>

                  <!-- 更多自定义内容 -->
                  <slot name="more" />

                  <el-button v-if="more?.bulkImport" v-permission:import size="small" @click="handleImport">
                    {{ $MGUI.i18n.t('批量导入') }}
                  </el-button>
                  <el-button v-if="more?.bulkUpdate" v-permission:bulkUpdate size="small" @click="hadnleUpdate">
                    {{ $MGUI.i18n.t('批量更新') }}
                  </el-button>
                  <el-button v-if="more?.exportApi" v-permission:export size="small" @click="handleExporting">
                    {{ $MGUI.i18n.t('导出') }}
                  </el-button>
                </div>
              </el-popover>
            </el-form-item>
          </el-form>
        </el-header>
        <slot name="platform"></slot>
        <el-main ref="main" style="background-color: white" v-loading.body="loading">
          <ul class="list" v-if="pageData.length">
            <li
              v-for="(item, index) in pageData"
              :key="index"
              :class="{ active: currentActive === index }"
              class="list-item flex flex-col justify-between"
              @click="onItemClick(item, index)"
            >
              <slot name="item" v-bind="{ item, index }"></slot>
            </li>
          </ul>
          <div class="list-empty" v-else>
            <img src="@/assets/common/empty-icon.png" />
            <div>{{ $MGUI.i18n.t('暂无内容') }}</div>
          </div>
        </el-main>
        <el-footer
          :height="$pxToRem(146)"
          style="background-color: white; padding: 0"
          class="flex items-center justify-between flex-col"
        >
          <pagination
            :style="{
              marginTop: $pxToRem(16),
            }"
            v-if="showPagination"
            :page="page"
            :total-page="totalPage"
            @page-change="handleCurrentChange"
          />
          <!-- 底部分页数据 -->
          <div class="list-footer flex items-center">
            <template v-if="customFooter">
              <slot name="custom-footer" v-bind="{ total }"></slot>
            </template>

            <mg-space v-else>
              <span>
                {{ $MGUI.i18n.t('共') }}
                <em>{{ total }}</em>
                {{ $MGUI.i18n.t('条') }}
              </span>
              <slot name="summary"></slot>
            </mg-space>
          </div>
        </el-footer>
      </el-container>
    </el-aside>

    <slot />
    <!-- 导入 -->
    <import-dialog
      ref="importDialog"
      v-if="more?.bulkImport"
      v-bind="more.bulkImport"
      :visible.sync="importVisible"
      @onSuccess="handleImportSuccess"
    ></import-dialog>

    <!-- 批量更新 -->
    <import-dialog
      ref="updateDialog"
      v-if="more?.bulkUpdate"
      v-bind="more.bulkUpdate"
      :visible.sync="updateVisible"
      @onSuccess="handleImportSuccess"
    ></import-dialog>

    <!-- 更多查询弹窗 -->
    <mg-dialog :visible.sync="moreSearchVisible" :showFooter="false" :title="$MGUI.i18n.t('更多查询')" width="60%">
      <mg-search-form
        class="more-search-form"
        ref="moreSearch"
        v-if="more?.moreSearch"
        v-bind="more.moreSearch"
        @getSearchFormData="handleSearchMore"
      ></mg-search-form>
    </mg-dialog>
  </el-container>
</template>

<script>
  import { downloadFile } from '@/utils'
  import { GlobalEventType } from '@/constants'
  import i18n from '@/locale'
  import JSScanner from '@/utils/JSScanner'
  import useShortcuts from '@/mixins/useShortcuts'
  import { keepAliveRoutes } from '@/config'

  export default {
    name: 'PosDualPaneContainer',

    mixins: [useShortcuts],

    components: {
      pagination: () => import('../components/pagination.vue'),
      importDialog: () => import('@/components/ImportDialog'),
    },

    props: {
      primaryKey: {
        type: String,
        default: '',
      },
      searchKeyField: {
        type: String,
        default: 'searchKey',
      },
      searchPlaceholder: {
        type: String,
        default: i18n.t('请输入'),
      },
      searchRules: {
        type: Array,
        default: () => [],
      },
      more: {
        type: Object,
        default: null,
        validator: (value) => {
          return Object.keys(value)?.every((i) =>
            ['bulkImport', 'moreSearch', 'bulkUpdate', 'exportApi', 'actions'].includes(i)
          )
        },
      },
      showPagination: {
        type: Boolean,
        default: true,
      },
      customFooter: {
        type: Boolean,
        default: false,
      },
      autoload: {
        type: Boolean,
        default: true,
      },

      // 列表接口 props
      api: Function,
      apiParams: Object,
      formatter: Function,
      showSearchForm: {
        type: Boolean,
        default: true,
      },
      /**
       * true：走快捷键中心扫码（可选）
       * false：本地 JSScanner（默认，保护全站列表）
       */
      useScanCenter: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      page() {
        return this.pagination.page
      },
      totalPage() {
        return Math.ceil(this.total / this.pagination.size)
      },
    },

    data() {
      return {
        searchForm: {},

        // 分页数据
        pageData: [],
        loading: false,
        total: 0,
        pagination: {
          page: this.apiParams?.page ?? 1,
          size: this.apiParams?.size ?? 20,
        },

        // 当前点击的 item
        currentActive: null,

        importVisible: false,

        updateVisible: false,

        moreSearchVisible: false,

        filterNoScanName: [
          // 'MemberInfo', //会员信息
         'MemberNonDiscountedGoods', //不折扣商品
         'MemberNonRewardGoods', //不记分商品
        //  'MemberTypes', //会员类型
        //  'GoodsInfo', //商品资料
         ], //这些页面不要响应扫码枪
        scannerAvailable: true,
        scannerPaused: false,
      }
    },

    activated() {},

    created() {
      // 自动加载数据
      if (this.api && this.autoload) {
        this.loadData(true)
      }
    },

    async mounted() {
      // console.log('TIPS dual-pane-container from mounted:', this.$router.currentRoute)
      // 初始化搜索参数
      this.$set(this.searchForm, this.searchKeyField, '')
      await this.$nextTick()
      this.$GlobalEventBus.on(GlobalEventType.FRESH_DUAL_PANE, this.loadData)
      this.$once('hook:beforeDestroy', () => {
        this.$GlobalEventBus.off(GlobalEventType.FRESH_DUAL_PANE, this.loadData)
      })

      const routerName = this.$router.currentRoute.name
      var needScanner = true
      this.filterNoScanName.forEach((item) => {
        if (routerName.indexOf(item) > -1) {
          needScanner = false
        }
      })

      this.scannerAvailable = needScanner
      this.scannerPaused = false

      if (this.useScanCenter) {
        this.bindShortcuts(
          {},
          {
            layer: 'widget',
            onScan: needScanner ? this.handleScannerInput : null,
          }
        )
        return
      }

      // 创建输入判断
      if (!this.JSScanner) {
        this.JSScanner = new JSScanner()
      }

      this.JSScanner.off()

      if (needScanner) {
        this.resumeScanner()
      }

      // 页面组件是否被缓存
      if (keepAliveRoutes.includes(this.$route.name)) {
        this.$once('hook:deactivated', () => {
          this.JSScanner.off()
        })
      } else {
        this.$once('hook:beforeDestroy', () => {
          this.JSScanner.off()
        })
      }
    },

    methods: {
      handleScannerInput(code, ifScanGun) {
        if (!this.scannerAvailable || this.scannerPaused) return
        if (ifScanGun) {
          this.searchForm['searchKey'] = code
          this.handleSearch()
        }
      },
      pauseScanner() {
        this.scannerPaused = true
        if (this.useScanCenter) {
          this.$shortcuts?.setOnScan?.(this._shortcutScopeId, null)
          return
        }
        this.JSScanner?.off?.()
      },
      resumeScanner() {
        if (!this.scannerAvailable) return
        this.scannerPaused = false
        if (this.useScanCenter) {
          this.$shortcuts?.setOnScan?.(this._shortcutScopeId, this.handleScannerInput)
          return
        }
        if (!this.JSScanner) return
        this.JSScanner.off()
        this.JSScanner.on(this.handleScannerInput)
      },
      setFocusInput(){
         this.$refs.headInput.focus()
      },
      handleSearch() {
        this.$refs.searchForm.validate((valid) => {
          if (valid) {
            this.handleCurrentChange(1)
          }
        })
      },

      async handleSearchMore(params) {
        this.moreSearchVisible = false
        this.searchForm = { ...this.searchForm, ...params }
        await this.$nextTick()
        this.handleCurrentChange(1)
      },

      handleCurrentChange(page) {
        this.currentActive = null
        if (page) {
          this.pagination.page = page
        }
        this.loadData(true)
      },

      /**
       *
       * @param {*} initial 是否初始化
       * initial 传参是对象的时候，只更新本地数据，解构 { update, key }
       */
      loadData(initial) {
        if (initial instanceof Object) {
          const { update, key } = initial
          const updateIndex = this.pageData.findIndex((item) => item[key] === update[key])
          if (updateIndex > -1) {
            this.$set(this.pageData, updateIndex, update)
            return
          }
        }

        this.loading = true
        return this.api({
          ...this.apiParams,
          ...this.pagination,
          ...this.searchForm,
        })
          .then((res) => {
            this.total = res.data?.total || 0
            return typeof this.formatter === 'function'
              ? this.formatter({ res, params: { ...this.apiParams, ...this.searchForm } })
              : res
          })
          .then((res) => {
            this.pageData = res.data?.items || []

            // 默认激活列表中的第一条
            if (initial && this.pageData.length) this.onItemClick(this.pageData[0], 0)
            if (this.total === 0) this.onItemClick(null, null)
          })
          .finally(() => {
            this.loading = false
          })
      },

      onItemClick(item, index) {
        if (!item && !index) return this.$emit('item-click', { total: this.total })
        this.currentActive = index
        this.$emit('item-click', { item, index, total: this.total })
      },

      handleAdd() {
        this.$emit('add')
      },

      moreSearch() {
        this.moreSearchVisible = true
      },

      handleImport() {
        this.importVisible = true
      },

      hadnleUpdate() {
        this.updateVisible = true
      },

      handleImportSuccess(data) {
        if (data?.success > 0) {
          // 初始化查询条件
          this.searchForm = { [this.searchKeyField]: '' }

          // 查询第一页数据
          this.handleCurrentChange(1)
        }
      },

      handleExporting(done) {
        const onDone = typeof done === 'function' ? done : () => {}
        const { exportApi } = this.more ?? {}
        if (typeof exportApi === 'function') {
          const sortBy = this.primaryKey ? { sortBy: `${this.primaryKey}:desc` } : {}
          exportApi({
            ...this.apiParams,
            ...this.searchForm,
            ...sortBy,
          })
            .then((data) => {
              downloadFile(data)
            })
            .finally(() => {
              onDone()
            })
        }
      },

      /**
       * 键盘 up 向上切换
       */
      selectUp() {
        if (this.currentActive === null) return
        if (this.currentActive === 0) return

        this.currentActive--

        if (this.$refs.main.$el.scrollTop > 72) {
          this.$refs.main.$el.scrollTop -= 72
        } else {
          this.$refs.main.$el.scrollTop = 0
        }

        setTimeout(() => {
          this.$emit('item-click', {
            item: this.pageData[this.currentActive],
            index: this.currentActive,
            total: this.total,
          })
        }, 400)
      },

      /**
       * 键盘 down 向下切换
       */
      selectDown() {
        if (this.currentActive === null) return
        if (this.currentActive === this.pageData.length - 1) return
        this.currentActive++

        // 容器高度 / 72 取整得到可容纳的行数，当切换到最后一行时，scrollTop + 72
        const clientRows = parseInt(this.$refs?.main?.$el.clientHeight / 72)
        if (this.currentActive >= clientRows) this.$refs.main.$el.scrollTop += 72

        setTimeout(() => {
          this.$emit('item-click', {
            item: this.pageData[this.currentActive],
            index: this.currentActive,
            total: this.total,
          })
        }, 400)
      },
    },
  }
</script>

<style lang="scss" scoped>
  .list {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    border: 1px solid $mg-border-color;

    &-item {
      height: 72px;
      border-bottom: 1px solid $mg-border-color;
      padding: 14px 16px;
      box-sizing: border-box;
      font-size: 16px;
      cursor: pointer;
      &:last-child {
        border-bottom: none;
      }
      &:hover {
        background-color: $mg-row-hover-color;
      }
      &.active {
        background: $mg-row-active-color;
        color: $mg--color-primary;
        ::v-deep(* :not(.mg-status)) {
          color: $mg--color-primary !important;
        }
      }

      ::v-deep(.text-ellipsis) {
        max-width: 262px;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        line-height: initial;
      }
    }
  }
  .list-empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: 100%;
    color: #a7a9b1;
    font-size: 18px;
    img {
      width: 160px;
    }
    div {
      margin-top: 16px;
    }
  }
  .list-footer {
    height: 84px;
    width: 100%;
    box-sizing: border-box;
    padding: 16px;
    border: 1px solid #e9e9eb;
    font-size: 18px;
    ::v-deep(em) {
      font-style: normal;
      font-weight: 400;
      color: $mg--color-primary;
    }
  }

  .search-form {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    .searchkey-form-item {
      flex: 1;
      margin-right: 8px;
      ::v-deep(.el-form-item__content) {
        width: 100%;
      }
    }

    ::v-deep(.el-form-item) {
      margin-bottom: 0;
    }

    ::v-deep(.el-input__inner) {
      width: 100%;
      height: 40px;
    }

    ::v-deep(.el-input--suffix .el-input__suffix) {
      top: -6px;
    }

    &__button {
      display: flex;
      align-items: center;
      ::v-deep(.el-button) {
        min-width: 0;
        width: 60px;
        height: 40px;
        padding: 0;
        font-size: 16px;
      }
      ::v-deep(.el-button + .el-button) {
        margin-left: 8px;
      }
    }
  }

  .search-form__more {
    .more-actions {
      ::v-deep(.el-button) {
        margin-left: 0;
        border: none;
        font-weight: normal;
      }

      ::v-deep(.el-button + .el-button) {
        margin-top: 8px;
      }
    }
  }

  // 更多查询弹窗：表单项保持左右一行显示（label 左、控件右）
  ::v-deep(.more-search-form .el-form-item) {
    display: flex;
    align-items: center;
  }
  ::v-deep(.more-search-form .el-form-item__label) {
    float: none;
    flex: 0 0 auto;
    padding-right: 12px;
    line-height: 40px;
  }
  ::v-deep(.more-search-form .el-form-item__content) {
    flex: 1;
    min-width: 0;
    margin-left: 0 !important;
  }
</style>
